import React, {useEffect} from 'react';
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import '../approval.scss'
import {baseUrl} from "../../../constants/constants";
import {stringify} from "node:querystring";
import {SubmitHandler, useForm} from "react-hook-form";

interface IToken {
    tmp_key: string
}

const Yes = () => {
    const {register,
        handleSubmit,
        formState:{errors},
        setError,
        watch,
        getValues} = useForm<IToken>()
    const [searchParams, setSearchParams] = useSearchParams()
    const tmp_key = searchParams.get('token')

    // const submit: SubmitHandler<IToken> = async (data) => {
    //     try{
    //         const res = await fetch(`${baseUrl}blank_forum/mailing/yes`,{
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({tmp_key})
    //         });
    //         if(res.status === 200){
    //             console.log(tmp_key)
    //         } else if(res.status === 401){
    //             setError('root', {type: 'custom', message:''})
    //         }
    //     } catch (err){
    //         console.error(err)
    //     }
    // }

    useEffect(() => {
        const res = fetch(`${baseUrl}blank_forum/mailing/yes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({tmp_key})
        })
    }, []);


    return (
        <div className={'approval-page'}>
            <h2 className={'approval-page__title'}>Вы подтвердили своё участие в форуме "Планёрка профилактики"</h2>
                <Link to='/'>
                    <button className={'button'}>На главную</button>
                </Link>
        </div>
    );
};

export default Yes;